import { render, staticRenderFns } from "./AddressTelephone.vue?vue&type=template&id=69312b0b&"
import script from "./AddressTelephone.vue?vue&type=script&lang=ts&"
export * from "./AddressTelephone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports